import { Pescador } from './../../../models/pescador';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';



@Component({
  selector: 'app-crecimiento',
  templateUrl: './crecimiento.component.html',
  styleUrls: ['./crecimiento.component.css']
})
export class CrecimientoComponent implements OnInit {
 datospescadores: Pescador[] = [];

  constructor(
    private rutaActiva: ActivatedRoute
    


  ) { }

  

  ngOnInit() {

     
     console.log (this.rutaActiva.snapshot.paramMap.get('listado.creado'));

   
    


}

}


